<template>
  <v-row justify="center" v-if="cuota">
    <v-dialog v-model="dialog" scrollable persistent max-width="650px">
      <v-card>
        <v-toolbar flat dark color="primary" class="max-height">
          <v-toolbar-title> Fecha Anterior: {{ cuota.date_pago }} <v-spacer></v-spacer> {{ cuota.concepto }} - {{ cuota.numero_cuota }} </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeDialog"> <v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-date-picker flat v-model="date" full-width no-title>
          <h4>Nueva Fecha: {{ fecha_pago }}</h4>
          <v-spacer></v-spacer>
          <v-btn color="success" rounded @click="assignNewDate(fecha_pago)"> <v-icon class="mr-1"> mdi-content-save</v-icon> Guardar Fecha </v-btn>
          <v-btn color="blue darken-1" outlined rounded @click="dialog = false"> Cancelar <v-icon> mdi-close</v-icon> </v-btn>
        </v-date-picker>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import xaxios from '@/xaxios';
export default {
  props: ['date_pago'],
  data() {
    return {
      menu_name: process.env.VUE_APP_NAME_MENU,
      api_rest: process.env.VUE_APP_API_REST,

      dialog: false,
      date: null,
      cuota: null,
      inscripcion: null,
      fecha_pago: null,
    };
  },
  watch: {
    dialog(val) {
      val || this.closeDialog();
    },
    date(value) {
      if (value) {
        const [year, month, day] = value.split('-');
        this.fecha_pago = `${day}/${month}/${year}`;
      }
    },
  },
  methods: {
    showThisView(ins, item) {
      this.dialog = true;
      this.cuota = item;
      this.date = item.fecha_pago;
      this.inscripcion = ins;
    },

    async assignNewDate(new_Date) {
      if (this.cuota.saldo === 0) {
        this.$root.$notify.show('Esta Cuota ya ha sido Cancelada, No es posible cambiar de fecha', { color: 'red' });
        this.closeDialog();
      } else {
        if (await this.$root.$confirm.open('Cambiar Fecha de pago', 'estas seguro ??', { color: 'orange' })) {
          const url = `${this.api_rest}/api/esam/inscripcion/change/plan/dates`;
          const formData = { inscripcion_id: this.inscripcion.id, cuotas: [{ cuota_id: this.cuota.plan_pago_id, fecha_pago: new_Date }] };

          xaxios
            .put(url, formData)
            .then((res) => {
              if (res.status == 200) {
                this.$root.$notify.show('Fecha de cuota Cambiada', { color: 'success' });
                this.$emit('update:date_pago', new_Date);
              }
            })
            .catch(({ response }) => this.$root.$notify.show(`${response.data.error}`, { color: 'red', x: 'right' }));
          this.closeDialog();
        }
      }
    },

    closeDialog() {
      this.dialog = false;
      this.date = null;
      this.cuota = null;
      this.inscripcion = null;
      this.fecha_pago = null;
    },
  },
};
</script>
<style>
.max-height {
  max-height: 4.5em;
}
</style>